export default __webpack_public_path__ + "static/media/DescribingPeople_12.afcdf85c.png";